export function accessibilityEnterCheck(e, cb) {
  if (e.key === " " || e.key === "32" || e.key === "Enter" || e.key === "13" || e.type === "click" || e.type === "change") {
    cb()
  }
}
